import React from 'react';

interface BodyProps {
  children: React.ReactNode;
}

const Body: React.FC<BodyProps> = ({ children }) => (
  <p className="text-[14px] leading-[1.75] text-content-secondary mb-[10px]">
    {children}
  </p>
);

export default Body;
